import { useTranslation } from 'react-i18next';
import EmptyState404Img from '../../../../common/assets/images/emptystates/404.svg';
import { resources } from '../../resources/resources';
import { Link } from 'react-router-dom';

export const NotFoundPage = () => {
  const { t: translate } = useTranslation();

  return (
    <div className="m-panel">
      <div className="empty-state es-404-page">
        <div className="es-image">
          <img src={EmptyState404Img} alt="Page not found illustration" />
        </div>
        <h3>{translate(resources.notFound.title)}</h3>
        <p>
          {translate(resources.notFound.text)}{' '}
          <Link to={translate(resources.notFound.link)}>
            {translate(resources.notFound.linkLabel)}
          </Link>
        </p>
        <div className="es-cta">
          <Link to="/" className="btn btn-solid btn-lg">
            <span className="btn-text">
              {translate(resources.notFound.action)}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
